import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=fbecc22a"
import script from "./AccountTab.vue?vue&type=script&lang=js"
export * from "./AccountTab.vue?vue&type=script&lang=js"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=fbecc22a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports